<template>
  <div class="esp_page_back_wrap">
    <div class="esp_page_back" :style="{backgroundColor: bgColor}">
      <div class="esp_back_head">
        <div class="esp_head_left">
          <i class="el-icon-back" @click="back()"></i>
          <span class="esp_split_line">|</span>
          <span class="esp_title_text">{{title}}</span>
        </div>
        <div>
          <slot name="btn"></slot>
        </div>
      </div>
      <div class="esp_back_body">
        <el-scrollbar class="esp_scrollbar">
          <slot></slot>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EspPageBack',
    data() {
      return {}
    },
    props: {
      title: {
        type: String,
        default: '-'
      },
      bgColor: {
        type: String,
        default: '#ffffff'
      }
    },
    methods: {
      // 退回按钮
      back: function () {
        this.$emit('toBack', null);
      }
    }
  }
</script>

<style lang="less">
  .esp_page_back_wrap {
    height: 100%;
    padding: 10px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    .esp_page_back {
      height: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 2px;
      box-shadow: 0 0 3px rgb(0 0 0 / 13%);
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;

      .esp_back_head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e8e8e8;
        min-height: 39px;
        padding: 0px 10px;

        .esp_head_left {
          display: flex;
          align-items: center;

          i {
            font-size: 20px;
            font-weight: bold;
            border-radius: 3px;
            padding: 4px;

            &:hover {
              cursor: pointer;
              background-color: #eeeeee;
            }
          }

          .esp_split_line {
            font-weight: bold;
            padding: 0px 4px 0px 2px;
          }

          .esp_title_text {
            font-weight: bold;
          }
        }
      }

      .esp_back_body {
        flex: 1;
        overflow: hidden;

        .el-scrollbar__view {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageBack.vue